<template>
  <div class="business_cooperation">
    <div class="banner" id="banner">
			<div class="banner_content">
				<!--<el-carousel  height="400px" :autoplay="true" :indicator-position="'none'">
					<el-carousel-item v-for="(item,index) in getbanners()" :key="index" style="width: 100%;" v-bind:style="{'background-color': item.color}">
							<img :src="item.image" />
						</el-carousel-item>
				</el-carousel>-->
				<div class="swiper-container">
						<div class="swiper-wrapper">
							<div class="swiper-slide" style="background-color: #C8D6FF;">
								<img src="../../../assets/images/front/bannercontact.png" alt="">
							</div>
						</div>
				</div>
			</div>
		</div>
    <section class="swhz">
			<div class="swhz_con clear">
					<div class="con_left fl ">
						<div class="left_title">联系我们</div>
						<div class="left_content">
							<div class="clear">
								<div class="con_icon phone fl">
									<img src="../../../assets/images/front/phone_icon.png" />
								</div>
								<div class="fl ml20">商务合作 ：17719991109（宋老师）</div>
							</div>
							<div class="clear">
								<div class="con_icon QQ fl">
									<img src="../../../assets/images/front/qq_icon.png" />
								</div>
								<div class="fl ml20">QQ：3588036337</div>
							</div>
							<div class="clear">
								<div class="con_icon QQ fl">
									<img src="../../../assets/images/front/qq_icon.png" />
								</div>
								<div class="fl ml20">QQ：2351918274</div>
							</div>
							<div class="clear">
								<div class="con_icon local fl">
									<img src="../../../assets/images/front/local_icon.png" />
								</div>
								<div class="fl ml20">公司地址：江西省南昌市昌北经济开发区菊圃路1818号太阳城</div>
							</div>
						</div>
					</div>
					<div class="con_right fl" >
						<div class="right_title">在线申请</div>
						<div class="right_content">
							<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="102px" class="demo-ruleForm" :label-position="labelPosition" >
								<el-form-item label="单位名称:" prop="companyName">
									<div class="label_img">
										<img src="../../../assets/images/front/company_icon.png" />
									</div>
									<el-input v-model="ruleForm.companyName" :maxlength="100"></el-input>
							  </el-form-item>
								<el-form-item label="联系人:" prop="contactsName" >
									<div class="label_img">
										<img src="../../../assets/images/front/person_icon.png" />
									</div>
									<el-input v-model="ruleForm.contactsName" :maxlength="32"></el-input>
								</el-form-item>
								<el-form-item label="联系电话:" prop="contactsPhone" >
									<div class="label_img">
										<img src="../../../assets/images/front/phone_icon.png" />
									</div>
									<el-input v-model="ruleForm.contactsPhone" :maxlength="20"></el-input>
								</el-form-item>
								<el-form-item label="留言:" prop="message" >
									<div class="label_img">
										<img src="../../../assets/images/front/message_icon.png" />
									</div>
									<el-input type="textarea" v-model="ruleForm.message" :maxlength="200"></el-input>
									<div class="remind">
										（商务经理将在1-3个工作日内联系您）
									</div>
								</el-form-item>

								<el-form-item class='subbtnbox'>
									<el-button type="primary" @click="submitForm()" class="subbtn" v-loading="loading">提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
		</section>
  </div>
</template>
<script type="text/babel">
import Swiper from 'swiper'
import commonService from '@/service/commonService'
import image from '../../../assets/images/front/bannercontact.png'
export default {
  data () {
    return {
      loading: false,
      ruleForm: {
        companyName: '',
        contactsName: '',
        contactsPhone: '',
        message: ''
      },
	    rules: {
        companyName: [
	            { required: true, message: '请输入单位名称', trigger: 'blur' }
	          ],
        contactsName: [
	            { required: true, message: '请输入联系人', trigger: 'blur' }
	          ],
        contactsPhone: [
	            { required: true, message: '请输入联系电话', trigger: 'blur' },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
	          ],
        message: [
	            { required: false, message: '请填写活动形式', trigger: 'blur' }
	          ]
	        },
	        activeName: '1',
	        labelPosition: 'left'
	  	}
  },
  name: 'business_cooperation',
  async mounted () {
    	let mySwiper = new Swiper('.swiper-container', {
      autoplay: false,
      loop: false
    })
  },
  methods: {
    	getbanners () {
	      return [
	      {
	      	image: image,
	      	color: '#fff'
	      }
	     ]
	    },
	    submitForm () {
      this.loading = true
      this.$refs['ruleForm'].validate(async (valid) => {
	          if (valid) {
          try {
            let data = await commonService.contractUs(this.ruleForm)
            this.loading = false
            this.$message({
              message: '申请成功,我们会稍后和您联系!',
              type: 'success'
            })
            this.$refs['ruleForm'].resetFields()
          } catch (e) {
            this.$message.error(e && e.msg)
            this.loading = false
          }
	          } else {
          this.loading = false
          this.$message.error('请完善您的信息')
	          }
	        })
	    }
  }
}
</script>
<style scoped>
  .business_cooperation{
    background-color: #ffffff;
  }
img{
	display: block;
}
.fl{
	float: left;
}
.ri{
	float: right;
}
.clear:after{
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.ml20{
	margin-left: 20px;
}
.banner_content img{
	margin: 0 auto;
	max-width: 100%;
}
.swhz{
	padding-top: 94px;
	padding-bottom: 50px;
	width: 100%;
	background: #F6F6F6 url(../../../assets/images/front/Layer9.png) bottom center no-repeat;
}
.swhz .swhz_title{
	font-size:36px;
	font-family:MicrosoftYaHei;
	font-weight:400;
	color:rgba(0,0,0,1);
	text-align: center;
}
.swhz .swhz_con{
	width: 1200px;
	height: 570px;
	margin: 0 auto;
	/*background: url(../../../assets/images/front/map.png);*/
}
.con_left{
	width: 50%;
}
.con_right{
	width: 50%;
}
.con_left .left_title{
	font-size:24px;
	font-family:MicrosoftYaHei;
	font-weight:400;
	color:rgba(0,0,0,1);
	text-align: center;
}
.con_left .left_content{
	margin-top: 33px;
}
.con_left .left_content div{

	font-size:18px;
	font-family:MicrosoftYaHei;
	font-weight:400;
	color:rgba(51,51,51,1);
	line-height: 53px;
}
.con_right .right_title{
	text-align: center;
	font-size:24px;
	font-family:MicrosoftYaHei;
	font-weight:400;
	color:rgba(0,0,0,1);
}
.right_content{
	margin-top: 51px;
}
.con_des{
	margin-top: 50px;
}
.phone{
	margin-top: 16px;
}
.QQ{
	margin-top: 18px;
}
.email{
	margin-top: 20px;
}
.local{
	margin-top: 16px;
}
	.label_img {
		width: 21px;
		height: 20px;
		position: absolute;
		left: -131px;
		top: 12px;
	}
</style>
<style>
  .business_cooperation #banner .banner_content .el-carousel__indicator .el-carousel__button{
		width:12px;
		height:12px;
		background:rgba(255,255,255,1);
		border-radius:50%;
		opacity: 1;
	}
	.business_cooperation #banner .banner_content .el-carousel__indicator.is-active .el-carousel__button{
		width:46px;
		height:12px;
		background:rgba(255,255,255,1);
		border-radius:6px;
	}
	.business_cooperation .right_content .el-input__inner{
		height: 35px;
	}
	.business_cooperation .right_content .el-textarea__inner{
		resize: none;
		height: 120px;
	}
	.business_cooperation .right_content .el-form-item{
		margin-bottom: 22px;
	}
	.business_cooperation .right_content .el-form-item__label{
		font-size:18px;
		font-family:MicrosoftYaHei;
		font-weight:400;
		color:rgba(51,51,51,1);
	}

	.business_cooperation .right_content .remind{
		font-size:18px;
		font-family:MicrosoftYaHei;
		font-weight:normal;
		color:rgba(51,51,51,1);
    text-align: left;
	}
	.business_cooperation .right_content .subbtnbox{
		margin-top: 36px;
		text-align: right;
	}
	.business_cooperation .right_content .subbtn{
		padding: 0;
    width: 111px;
    height: 38px;
    border-radius: 6px;
    border: none;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
	}
	.business_cooperation .right_content .subbtn:hover{
		color: white;
	}
	.business_cooperation .right_content .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		content: "";
	}
	.business_cooperation .right_content  .el-input__inner,
	.business_cooperation .right_content .el-textarea__inner{
		border:1px solid rgba(220,223,230,1);
		border-radius:4px;
		background: transparent;
	}

  .business_cooperation .right_content .el-form-item.is-success .el-input__inner,
  .business_cooperation .right_content .el-form-item.is-success .el-textarea__inner{
    border:1px solid rgba(220,223,230,1);
		border-radius:4px;
  }

  .business_cooperation .right_content  .el-form-item .el-input__inner:focus,
  .business_cooperation .right_content   .el-form-item .el-textarea__inner:focus{
    border:1px solid rgba(16,142,233,1);
		box-shadow:0px 6px 10px 0px rgba(16,142,233,0.1);
    border-radius:4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/business-cooperation/index.vue